export const utilityPlanEnrollmentInfoQuery = `
  query UtilityPlanEnrollmentInfo($input: UtilityPlanEnrollmentInfoInput!) {
    utilityPlanEnrollmentInfo(input: $input) {
      utilityPlanEnrollmentInfo {
        availableDates {
          switchServiceDates
        }
        disclaimers,
        fees {
          distributorFees {
            moveInCharges
          }
        }
        requiredPlanEnrollmentFields {
          content,
          dependentKey,
          dependentValue,
          errorMessage,
          inputType,
          key,
          label,
          options,
          regex,
          required,
        }
        terms
      }
    }
  }
`;
